import React from "react";
import { Route } from "react-router-dom";
import { GlossyThemeProvider } from "@glossy";
import Navbar from "@radarly/components/navigation/navbar";
import Help from "@radarly/components/navigation/navbar/help";
import { useNavbar } from "@radarly/core/navigation/use-cases";
import { useOpenPanel } from "@radarly/core/panel/use-cases";
import { useCurrentUser } from "@radarly/core/user/use-cases";
import { IRouterService } from "@radarly/shared/router";
import { NavbarFeatures } from "./features";
import { NavbarPages } from "./pages";
import { NavbarScope } from "./scope";
import { NavbarWarmups } from "./warmups";

interface NavigationNavbarProps {
  router: IRouterService;
  onOpenPanel: (panel: string) => void;
  hideFeatures?: boolean;
}

export function NavigationNavbar({
  onOpenPanel,
  router,
  hideFeatures,
}: NavigationNavbarProps) {
  const openPanel = useOpenPanel();
  const { homeUrl, isLoading, hasPages, locale, products } = useNavbar(router);
  const user = useCurrentUser();
  return (
    <GlossyThemeProvider name="header">
      <Route path="/project/:project/*" exact={false}>
        {({ match }) => {
          return (
            <Navbar
              homeUrl={homeUrl}
              products={products}
              loading={isLoading(match ? parseInt(match.params.project) : 0)}
              openProfile={() => onOpenPanel("profile")}
              pages={hasPages ? <NavbarPages router={router} /> : null}
              scope={
                <NavbarScope onClick={() => openPanel({ type: "switcher" })} />
              }
              warmups={<NavbarWarmups />}
              help={<Help locale={locale} onClickHelp={onOpenPanel} />}
              features={
                !hideFeatures && (
                  <NavbarFeatures onOpenPanel={onOpenPanel} router={router} />
                )
              }
              locale={locale}
              user={user}
            />
          );
        }}
      </Route>
    </GlossyThemeProvider>
  );
}
